import type { CardPayoffRateSet } from "./types.js";

// Benchmark / default constants for the credit-card-payoff calculator, effective
// from the RBA F5 observation dated 5 June 2026. These are DEFAULTS and CONTEXT
// ONLY — they reprice each month but do NOT gate the maths. The user's own rate
// and chosen repayment are the inputs that drive every figure. Never edit a
// shipped set to refresh a later observation — author a new rates-YYYY-MM-DD.ts.
//
// Verified figures (see verification/credit-card-payoff-figures.md):
//  - Figure #1 (CITED): RBA F5 series FILRPLRCCS "Lending rates; Personal loans;
//    Revolving credit; Credit cards; Standard" = 20.99% p.a., latest obs
//    05-Jun-2026. Query F5 by SERIES ID, not column position (the table holds
//    many lending-rate series; a position-based read returned 10.76%).
//  - Figure #2 (CITED): RBA F5 series FILRPLRCCL "…Credit cards; Low rate" =
//    13.49% p.a., latest obs 05-Jun-2026.
//  - Figure #5 (CITED): ASIC MoneySmart minimum-repayment rule — "typically 2 or
//    2.5%, or a set dollar amount (usually around $20), whichever is greater;
//    your minimum repayment will never be more than your closing balance." We
//    encode the conservative 2% / $20 as the typical default.
export const rates_2026_06_05: CardPayoffRateSet = {
  effectiveFrom: "2026-06-05",
  effectiveTo: null,
  label: "Card payoff benchmarks effective 5 June 2026",
  sources: {
    standardRate:
      "https://www.rba.gov.au/statistics/tables/csv/f5-data.csv", // series FILRPLRCCS
    lowRate: "https://www.rba.gov.au/statistics/tables/csv/f5-data.csv", // series FILRPLRCCL
    minimumRepayment: "https://moneysmart.gov.au/credit-cards/credit-card-calculator",
  },
  sourcesVerifiedAt: "2026-06-22",
  standardRate: 0.2099,
  lowRate: 0.1349,
  typicalMinimum: {
    percentOfBalance: 0.02,
    dollarFloor: 20,
  },
};
